export enum OkkComplaintStatusEnum {
    NotProcessed, //not used
    ProcessedWithOffense,
    Processed,
    Protest,
    InProgressByInspector, //not used
    InProgressByManager, //not used
    InProgress,
    FeedbackClarification, //not used
    WaitingDecision,
}
